import ProceedButton from '../components/ProceedButton';

export default function InstructionScreen() {
  return (
      <div className='flex flex-row justify-center'>
        <div className='flex flex-col w-8/12 lg:w-4/12 items-center'>
          <div className='text-xl'>
            <p> Al fine di poter proseguire con la firma dei contratti digitali le chiederemo i seguenti dati: </p>
            <ol className={`${accentText} my-8 list-disc`}>
              <li> Nome e cognome </li>
              <li> Indirizzo di residenza </li>
              <li> Codice Fiscale </li>
              <li> Città di nascita </li>
            </ol>
            <p> Le sarà richiesto inoltre anche il caricamente di due foto, fronte-retro, del suo
              <span className={accentText}> documento d’identità</span> e
              <span className={accentText}> codice fiscale</span>.
            </p>
          </div>
          <div className='h-8' />
          <ProceedButton route={'/primo-step'} />
        </div>
      </div>
  );
}

const accentText = "font-bold text-orange-600";
